module.exports = __webpack_public_path__ + "img/_2.e885f97a.png";